<template>
  <div
    :class="{ snackbar: true, show: isShow, [type]: true }"
    v-html="message"
  ></div>
</template>

<script>
export default {
  name: "base-snackbar",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    type: {
      type: String, // info / error
      default: "error",
    },
  },
};
</script>
